import type { Status } from '../../design-system/primitives/StatusPill/StatusPill';
import type { SmsMessageStatus } from '../../lib/api/sms';

/**
 * An SMS status -> the `StatusPill` variant that renders it, so a message
 * list can use the design system's own pill (dot + word, readable without
 * colour) instead of a fourth hand-rolled copy of the palette.
 *
 * THE SAME FIVE PAIRINGS `CaseMessages.module.css`/`SendSmsScreen.module.css`
 * already draw by hand, token for token: queued is the `waiting` ground,
 * sending `in-progress`, sent `closed`, failed `escalated`, rejected
 * `cancelled`. A closed `Record` over `SmsMessageStatus`, so a sixth status
 * is a compile error here rather than an unstyled pill.
 */
export const SMS_STATUS_PILL: Readonly<Record<SmsMessageStatus, Status>> = {
  queued: 'waiting',
  sending: 'in-progress',
  sent: 'closed',
  failed: 'escalated',
  rejected: 'cancelled',
};
